import { render, staticRenderFns } from "./StatistiquesInscritsPoint.vue?vue&type=template&id=a9ce63c0&scoped=true&"
import script from "./StatistiquesInscritsPoint.vue?vue&type=script&lang=js&"
export * from "./StatistiquesInscritsPoint.vue?vue&type=script&lang=js&"
import style0 from "./StatistiquesInscritsPoint.vue?vue&type=style&index=0&id=a9ce63c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ce63c0",
  null
  
)

export default component.exports